// LIST
export const FETCH_FIELDS = "app/FIELD/FETCH_FIELDS";
export const FETCH_FIELDS_SUCCESS = "app/FIELD/FETCH_FIELDS_SUCCESS";
export const FETCH_FIELDS_FAILURE = "app/FIELD/FETCH_FIELDS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/FIELD/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/FIELD/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/FIELD/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_FIELD = "app/FIELD/ADD_FIELD";
export const ADD_FIELD_SUCCESS = "app/FIELD/ADD_FIELD_SUCCESS";
export const ADD_FIELD_FAILURE = "app/FIELD/ADD_FIELD_FAILURE";

// EDIT
export const EDIT_FIELD = "app/FIELD/EDIT_FIELD";
export const EDIT_FIELD_SUCCESS = "app/FIELD/EDIT_FIELD_SUCCESS";
export const EDIT_FIELD_FAILURE = "app/FIELD/EDIT_FIELD_FAILURE";

// DELETE
export const DELETE_FIELD = "app/FIELD/DELETE_FIELD";
export const DELETE_FIELD_SUCCESS = "app/FIELD/DELETE_FIELD_SUCCESS";
export const DELETE_FIELD_FAILURE = "app/FIELD/DELETE_FIELD_FAILURE";

export const TOGGLE_FIELD_ADD_MODAL = "app/FIELD/TOGGLE_FIELD_ADD_MODAL";

export const UPDATE_FIELD_ORDER = "app/FIELD/UPDATE_FIELD_ORDER";
export const UPDATE_FIELD_ORDER_SUCCESS =
  "app/FIELD/UPDATE_FIELD_ORDER_SUCCESS";
export const UPDATE_FIELD_ORDER_FAILURE =
  "app/FIELD/UPDATE_FIELD_ORDER_FAILURE";
